import {
  Component,
  DestroyRef,
  Inject,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ToastAlertService } from '@core/services';

import { Floor, TypeOfJob, User, WorkPlaceGroup } from '../../../models';
import { WorkplaceTypeService } from '../../../services/workplace-type.service';
import { WorkplaceService } from '../../../services/workplace.service';
import { Workplace } from '../../../models/workplace.model';
import {
  BusinessService,
  UserService,
  WorkplaceGroupService,
} from '../../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { SelectComponent } from '@shared/components/select/select.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  templateUrl: './new-job.component.html',
  styles: [
    `
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px; /* Ajusta el margen inferior según sea necesario */
      }

      .checkbox-item {
        font-size: 1.2rem;
        cursor: pointer;
        margin-bottom: 10px; /* Ajusta el espacio entre los checkboxes y el texto según sea necesario */
      }

      .checkbox-item.checked {
        color: #4caf50;
        font-weight: bold;
      }
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 20px;
      }

      .checkbox-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .checkbox-item mat-checkbox {
        margin-bottom: 5px;
      }
    `,
  ],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    InputComponent,
    MatFormFieldModule,
    MatInputModule,
    SelectComponent,
    MatListModule,
    MatCheckboxModule,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
})
export class NewJobComponent implements OnInit {
  issParking = signal(0);
  workerisparking = signal<any[]>([]);
  constructor(
    public dialogRef: MatDialogRef<NewJobComponent>,
    private FormBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogRef.disableClose = true; //permite no cerrar el modal.
    if (this.data.isparking === '1') {
      this.issParking.set(1);
    }
  }

  #WorkerService = inject(UserService);

  private destroyRef = inject(DestroyRef);
  private alertService = inject(ToastAlertService);
  private WorkplaceTypeService = inject(WorkplaceTypeService);
  private workplaceService = inject(WorkplaceService);
  private diagolRef = inject(MatDialogRef);
  private workplaceGroupService = inject(WorkplaceGroupService);
  #businessService = inject(BusinessService);

  formNewJob!: FormGroup;
  floors: Floor[] = [];
  ptypeJobs: TypeOfJob[] = [];
  workplaceGroups: WorkPlaceGroup[] = [];

  ngOnInit(): void {
    this.buildForm();
    this.deshabilitarCamposXY();
    this.chargueTypeJobs();
    this.chargueWorkplace();
    this.chargeworkerforparking();
  }
  filterPhone =
    '^\\+?\\(?[1-9]\\d{0,2}\\)?\\s?\\d{1,4}\\s?\\d{1,4}\\s?\\d{0,4}$';

  //Controlar el formulario
  private buildForm() {
    if (this.issParking() !== 1) {
      this.formNewJob = this.FormBuilder.group({
        name: ['', Validators.required],
        description: ['', Validators.required],
        phone: ['', [Validators.pattern(this.filterPhone)]],
        x: [{ value: this.data.x, disabled: true }, Validators.required],
        y: [{ value: this.data.y, disabled: true }, Validators.required],
        status: [1, Validators.required],
        workplacetypeid: ['', Validators.required],
        floorid: [this.data.idfoor, Validators.required],
        workplacegroupid: ['', Validators.required],
        monday: [true],
        tuesday: [true],
        wednesday: [true],
        thursday: [true],
        friday: [true],
        saturday: [false],
        sunday: [false],
      });
    } else {
      this.formNewJob = this.FormBuilder.group({
        name: ['', Validators.required],
        description: ['', Validators.required],
        phone: ['', [Validators.pattern(this.filterPhone)]],
        x: [{ value: this.data.x, disabled: true }, Validators.required],
        y: [{ value: this.data.y, disabled: true }, Validators.required],
        status: [1, Validators.required],
        workplacetypeid: ['', Validators.required],
        floorid: [this.data.idfoor, Validators.required],
        workplacegroupid: ['', Validators.required],
        monday: [true],
        tuesday: [true],
        wednesday: [true],
        thursday: [true],
        friday: [true],
        saturday: [false],
        sunday: [false],
        assignedWorker: [''],
        startDate: [''],
        endDate: [''],
      });
    }
  }

  deshabilitarCamposXY() {
    this.formNewJob.get('x')?.disable(); // Deshabilitar el campo x
    this.formNewJob.get('y')?.disable(); // Deshabilitar el campo y
  }

  convertirFormato(fecha: Date) {
    if (fecha) {
      // Convertir la cadena de fecha a un objeto Date
      var date = new Date(fecha);

      // Obtener los componentes de la fecha
      var dia = date.getDate();
      var mes = date.getMonth() + 1; // Los meses en JavaScript van de 0 a 11, por eso se suma 1
      var año = date.getFullYear();

      // Formatear la fecha en el formato dd-mm-YYYY
      var fechaFormateada =
        (dia < 10 ? '0' : '') +
        dia +
        '-' +
        (mes < 10 ? '0' : '') +
        mes +
        '-' +
        año;

      return fechaFormateada;
    } else {
      return undefined;
    }
  }

  onSubmit() {
    //Ingresar datos
    if (this.issParking() === 1) {
      console.log('ES PARQUEO');
      const formData: Workplace = {
        name: this.formNewJob.value['name'],
        description: this.formNewJob.value['description'],
        phone: this.formNewJob.value['phone'],
        x: this.data.x,
        y: this.data.y,
        status: this.formNewJob.value['status'],
        workplacetypeid: this.formNewJob.value['workplacetypeid'],
        floorid: this.formNewJob.value['floorid'],
        roleid: this.formNewJob.value['roleid'],
        workplacegroupid:
          this.formNewJob.value['workplacegroupid'] == 0
            ? null
            : this.formNewJob.value['workplacegroupid'],

        monday: this.formNewJob.value['monday'] ? 1 : 0,
        tuesday: this.formNewJob.value['tuesday'] ? 1 : 0,
        wednesday: this.formNewJob.value['wednesday'] ? 1 : 0,
        thursday: this.formNewJob.value['thursday'] ? 1 : 0,
        friday: this.formNewJob.value['friday'] ? 1 : 0,
        saturday: this.formNewJob.value['saturday'] ? 1 : 0,
        sunday: this.formNewJob.value['sunday'] ? 1 : 0,
        assignedWorker: this.formNewJob.value['assignedWorker'],
        startDate: this.convertirFormato(this.formNewJob.value['startDate']),
        endDate: this.convertirFormato(this.formNewJob.value['endDate']),
      };
      if (formData.assignedWorker == null || formData.assignedWorker === '') {
        delete formData.assignedWorker;
      }
      if (formData.startDate == undefined) {
        delete formData.startDate;
      }
      if (formData.endDate == undefined) {
        delete formData.endDate;
      }

      console.log('ES PARQUEO', formData);
      this.workplaceService
        .storeworkplace(formData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (request: any) => {
            if (request.code === 10000) {
              if (this.issParking() === 1) {
                this.alertService.sucess('Parqueo creado exitosamente');
              } else {
                this.alertService.sucess(
                  'Puesto de trabajo creado exitosamente'
                );
              }

              this.diagolRef.close('recargar'); //Recargar
            } else {
              this.alertService.error(request.detail);
            }
          },
        });
    } else {
      console.log('NO ES PARQUEO');
      const formData: Workplace = {
        name: this.formNewJob.value['name'],
        description: this.formNewJob.value['description'],
        phone: this.formNewJob.value['phone'],
        x: this.data.x,
        y: this.data.y,
        status: this.formNewJob.value['status'],
        workplacetypeid: this.formNewJob.value['workplacetypeid'],
        floorid: this.formNewJob.value['floorid'],
        roleid: this.formNewJob.value['roleid'],
        workplacegroupid:
          this.formNewJob.value['workplacegroupid'] == 0
            ? null
            : this.formNewJob.value['workplacegroupid'],

        monday: this.formNewJob.value['monday'] ? 1 : 0,
        tuesday: this.formNewJob.value['tuesday'] ? 1 : 0,
        wednesday: this.formNewJob.value['wednesday'] ? 1 : 0,
        thursday: this.formNewJob.value['thursday'] ? 1 : 0,
        friday: this.formNewJob.value['friday'] ? 1 : 0,
        saturday: this.formNewJob.value['saturday'] ? 1 : 0,
        sunday: this.formNewJob.value['sunday'] ? 1 : 0,
      };
      console.log('NO ES PARQUEO', formData);
      this.workplaceService
        .storeworkplace(formData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (request: any) => {
            if (request.code === 10000) {
              if (this.issParking() === 1) {
                this.alertService.sucess('Parqueo creado exitosamente');
              } else {
                this.alertService.sucess(
                  'Puesto de trabajo creado exitosamente'
                );
              }

              this.diagolRef.close('recargar'); //Recargar
            } else {
              this.alertService.error(request.detail);
            }
          },
        });
    }
  }

  //*Charge Combo clientes con parqueo

  chargeworkerforparking() {
    this.#WorkerService
      .WithOutParking(this.data.businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            this.workerisparking.set(resp.reply);
            console.log(this.workerisparking());
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  //*Chargue combo of type jobs
  async chargueTypeJobs() {
    //this.WorkplaceTypeService.getWorkplaces()
    this.WorkplaceTypeService.getWorkplacesByFloorId(this.data.idfoor)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          console.log(resp);
          if (resp.code === 10000) {
            this.ptypeJobs = resp.reply || [];

            if (this.issParking() === 1) {
              this.ptypeJobs = this.ptypeJobs.filter(
                item => item.name === 'PARQUEO'
              );
            } else {
              this.ptypeJobs = this.ptypeJobs.filter(
                item => item.name !== 'PARQUEO'
              );
            }
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  //*grupo de Tipos de puestos de trabajo
  chargueWorkplace() {
    this.workplaceGroupService
      .getWorkplaces(this.#businessService.business())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          this.workplaceGroups.push({
            workplaceid: 0,
            name: '-- Por defecto --',
            description: 'description',
            id: 0,
          });
          if (resp.code === 10000) {
            console.log('error', resp.reply);
            if (Array.isArray(resp.reply)) {
              this.workplaceGroups = this.workplaceGroups.concat(resp.reply);
            } else {
              this.workplaceGroups.push(resp.reply || '');
            }
            console.log('DATOS PARA LLENAR', this.workplaceGroups);
          }
        },
        error: error => {
          this.alertService.error(error);
        },
      });
  }

  clearForm() {
    this.buildForm();
  }
}
